import React from 'react'
import { motion } from "framer-motion";
import PizzaOne from '../../../assets/images/contact-us/image-one-parallax.webp'
import './company-info.css'

const ContactUsLanding = () => {
  return (
    <section className="homepage__company-info flex-container flex-row txt-white" >
      <motion.img
        initial={{ opacity: 0, right: 100 }}
        whileInView={{ opacity: 0.8, right: 300, }}
        exit={{ opacity: 0 }}
        transition={{ duration: 2 }}
        src={PizzaOne} alt="" aria-hidden="true" className="parallax company-info__img"
        loading='lazy'
      />
      <motion.img
        initial={{ opacity: 0, right: 100 }}
        whileInView={{ opacity: 0.8, right: 200, }}
        exit={{ opacity: 0 }}
        transition={{ duration: 2 }}
        src={PizzaOne} alt="" aria-hidden="true" className="parallax company-info__img" loading='lazy'
      />
      <motion.img
        initial={{ opacity: 0, right: 50 }}
        whileInView={{ opacity: 0.8, right: 100, }}
        exit={{ opacity: 0 }}
        transition={{ duration: 2 }}
        src={PizzaOne} alt="" aria-hidden="true" className="parallax company-info__img" loading='lazy'
      />
      <section className='company-info__details'>
        <div>
        <a href="tel:+436601919689" className="footer__contact__link">
          <h2>+43 660 19 19 689</h2>
          </a>
          <p>Kontaktieren Sie uns bei Fragen</p>
        </div>
        <div>
          <h2>Itzlinger Hauptstrasse 17</h2>
          <p>5020, Salzburg</p>
        </div>
        <div>
          <h2>Öffnungszeiten</h2>
          <p>Montag – Freitag: 11:00 - 14:30 & 17:00 - 22:00</p>
          <p>Samstag – Sonntag: 14:00 - 22:00</p>
        </div>
      </section>
    </section>
  );

}


export default ContactUsLanding;